import { AlarmTabsEnum } from '@components/routes/AdminPanel/Alarms/enums';

export const tabs = [
	{
		title: 'Active alarms',
		value: AlarmTabsEnum.activeAlarms,
		isVisible: true,
	},
	{
		title: 'Alarms history',
		value: AlarmTabsEnum.alarmsHistory,
		isVisible: true,
	},
];

export const ALARMS_SEARCH_PLACEHOLDER = 'ID / Name / Group / Site ID / Flex-5G';
export const ALARMS_ORAN_SEARCH_PLACEHOLDER = 'Name';
export const ALARMS_ORAN_SEARCH_PLACEHOLDER_HISTORY = 'Name / Severity / Module';
export const ALARMS_FLEXIDAS_SEARCH_PLACEHOLDER = 'ID / Name';
export const EXPORT_ALARMS_TOOLTIP_TEXT = 'Export alarms to file';
